module.exports = __webpack_public_path__ + "img/blip_router.b97f32d1.svg";